const mobileMenu = document.getElementById('mobile-menu');
const mobileMenuButton = document.getElementById('mobile-menu-button');

mobileMenu.addEventListener('toggle', (event) => {
  const closedMenu = document.getElementById('mobile-menu-closed');
  const openMenu = document.getElementById('mobile-menu-open');

  if (event.newState === 'open') {
    window.scrollTo(0, 0);
    closedMenu.classList.add('hidden');
    openMenu.classList.remove('hidden');
    document.body.classList.add('overflow-y-hidden')
  } else {
    closedMenu.classList.remove('hidden');
    openMenu.classList.add('hidden');
    document.body.classList.remove('overflow-y-hidden')
  }
});
